angular.module('gym.calendar').directive('eventScheduleRepeats', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_schedule/repeats/event_schedule_repeats.html.slim'),
    scope: {
      gym: '=',
      event: '=',
      permissions: '=',
      classrooms: '=',
      eventTypes: '=',
      styles: '=',
      onEdit: '&',
      cancelEdit: '&',
      reloadEvent: '&',
      save: '&'
    },
    controller: ["$scope", "$state", "$filter", "$modal", "$q", "flash", "loadingAnimation", "EditEventService", "EditEventScheduleService", "MessageService", function($scope, $state, $filter, $modal, $q, flash, loadingAnimation, EditEventService, EditEventScheduleService, MessageService) {
      var save, setNewInstructorModal;
      $scope.days = EditEventService.getDays();
      $scope.showBulkRescheduleRestrictionModal = function() {
        return MessageService.message({
          title: 'Bulk-reschedule not allowed',
          message: ['Bulk-reschedule functionality is not available for this event, as it was previously included in a "this and all future events" cancellation.', 'Instead, you may move this event to a new date or time using the "Reschedule this event only" option.']
        });
      };
      $scope.isRepeating = function() {
        return !!$scope.event.repeats || !!$scope.event.repeat_until_date || !!$scope.event.infinite;
      };
      $scope.repeatsDiff = function() {
        return $scope.event.original_repeats - $scope.event.repeats;
      };
      $scope.repeatsDiffAbs = function() {
        return Math.abs($scope.repeatsDiff());
      };
      $scope.isWeekly = function() {
        return $scope.event.repeat_interval_unit === 'week';
      };
      setNewInstructorModal = function(eventCopy, classrooms, eventTypes, styles, save) {
        return $modal.open({
          template: require('templates/gyms/calendar/events/edit_event_schedule/edit_event_no_instructors_modal.html.slim'),
          controller: ["$scope", "$modalInstance", function($scope, $modalInstance) {
            $scope.cancel = function() {
              return $modalInstance.dismiss('cancel');
            };
            return $scope.editEventGeneral = function() {
              $scope.cancel();
              return $modal.open({
                template: require('templates/gyms/calendar/events/edit_event_schedule/general/edit_event_schedule_general.html.slim'),
                windowClass: 'drawer__wrapper',
                backdropClass: 'modal-backdrop--drawer',
                controller: 'EditEventScheduleGeneralCtrl',
                resolve: {
                  params: function() {
                    return {
                      event: eventCopy,
                      save: save,
                      classrooms: classrooms,
                      styles: styles,
                      eventTypes: eventTypes,
                      cancelEdit: $scope.cancel
                    };
                  }
                }
              });
            };
          }]
        });
      };
      save = function(params) {
        var deferred;
        deferred = $q.defer();
        EditEventScheduleService.precheck($scope.event.id, params).then(function() {
          loadingAnimation.show();
          return EditEventScheduleService.updateFrequency($scope.event.id, params).then(function() {
            loadingAnimation.hide();
            $scope.reloadEvent();
            flash.success = 'Updated successfully';
            return deferred.resolve();
          }, function(response) {
            loadingAnimation.hide();
            flash.error = response.data.error_message;
            return deferred.reject();
          });
        }, function() {
          return deferred.reject();
        });
        return deferred.promise;
      };
      $scope.showRescheduleSingleEventForm = function() {
        var eventCopy;
        eventCopy = $scope.event.clone();
        if (!eventCopy.instructor_ids.length) {
          setNewInstructorModal(eventCopy, $scope.classrooms, $scope.eventTypes, $scope.styles, $scope.save);
          return;
        }
        $scope.onEdit();
        return $modal.open({
          template: require('templates/gyms/calendar/events/edit_event_schedule/repeats/reschedule_single_event.html.slim'),
          windowClass: 'drawer__wrapper',
          backdropClass: 'modal-backdrop--drawer',
          controller: 'RescheduleSingleEventCtrl',
          resolve: {
            params: function() {
              return {
                event: $scope.event.clone(),
                cancelEdit: $scope.cancelEdit,
                reloadEvent: $scope.reloadEvent,
                save: save
              };
            }
          }
        });
      };
      $scope.showRescheduleFutureEventsForm = function() {
        var eventCopy;
        if ($scope.event.uncancelled_after_bulk_event_cancellation) {
          $scope.showBulkRescheduleRestrictionModal();
          return;
        }
        eventCopy = $scope.event.clone();
        if (!eventCopy.instructor_ids.length) {
          setNewInstructorModal(eventCopy, $scope.classrooms, $scope.eventTypes, $scope.styles, $scope.save);
          return;
        }
        $scope.onEdit();
        return $modal.open({
          template: require('templates/gyms/calendar/events/edit_event_schedule/repeats/reschedule_future_events.html.slim'),
          windowClass: 'drawer__wrapper',
          backdropClass: 'modal-backdrop--drawer',
          controller: 'RescheduleFutureEventsCtrl',
          resolve: {
            params: function() {
              return {
                event: $scope.event.clone(),
                cancelEdit: $scope.cancelEdit,
                reloadEvent: $scope.reloadEvent,
                save: save
              };
            }
          }
        });
      };
      $scope.showChangeFrequencyForm = function() {
        var eventCopy;
        if ($scope.event.uncancelled_after_bulk_event_cancellation) {
          $scope.showBulkRescheduleRestrictionModal();
          return;
        }
        eventCopy = $scope.event.clone();
        if (!eventCopy.instructor_ids.length) {
          setNewInstructorModal(eventCopy, $scope.classrooms, $scope.eventTypes, $scope.styles);
          return;
        }
        $scope.onEdit();
        return $modal.open({
          template: require('templates/gyms/calendar/events/edit_event_schedule/repeats/change_events_frequency.html.slim'),
          windowClass: 'drawer__wrapper',
          backdropClass: 'modal-backdrop--drawer',
          controller: 'ChangeEventsFrequencyCtrl',
          resolve: {
            params: function() {
              return {
                event: $scope.event.clone(),
                cancelEdit: $scope.cancelEdit,
                reloadEvent: $scope.reloadEvent,
                showChangeWeeklySessionTimeForm: $scope.showChangeWeeklySessionTimeForm,
                save: save
              };
            }
          }
        });
      };
      $scope.showChangeWeeklySessionTimeForm = function() {
        var eventCopy;
        if ($scope.event.uncancelled_after_bulk_event_cancellation) {
          $scope.showBulkRescheduleRestrictionModal();
          return;
        }
        eventCopy = $scope.event.clone();
        if (!eventCopy.instructor_ids.length) {
          setNewInstructorModal(eventCopy, $scope.classrooms, $scope.eventTypes, $scope.styles);
          return;
        }
        $scope.onEdit();
        return $modal.open({
          template: require('templates/gyms/calendar/events/edit_event_schedule/repeats/change_weekly_session_time.html.slim'),
          windowClass: 'drawer__wrapper',
          backdropClass: 'modal-backdrop--drawer',
          controller: 'ChangeWeeklySessionTimeCtrl',
          resolve: {
            params: function() {
              return {
                event: $scope.event.clone(),
                cancelEdit: $scope.cancelEdit,
                reloadEvent: $scope.reloadEvent,
                showChangeFrequencyForm: $scope.showChangeFrequencyForm,
                save: save
              };
            }
          }
        });
      };
      $scope.showChangeRepeatRuleForm = function() {
        var eventCopy;
        if ($scope.event.uncancelled_after_bulk_event_cancellation) {
          $scope.showBulkRescheduleRestrictionModal();
          return;
        }
        eventCopy = $scope.event.clone();
        if (!eventCopy.instructor_ids.length) {
          setNewInstructorModal(eventCopy, $scope.classrooms, $scope.eventTypes, $scope.styles);
          return;
        }
        $scope.onEdit();
        return $modal.open({
          template: require('templates/gyms/calendar/events/edit_event_schedule/repeats/change_repeat_limit.html.slim'),
          windowClass: 'drawer__wrapper',
          backdropClass: 'modal-backdrop--drawer',
          controller: 'ChangeRepeatLimitCtrl',
          resolve: {
            params: function() {
              return {
                event: $scope.event.clone(),
                cancelEdit: $scope.cancelEdit,
                reloadEvent: $scope.reloadEvent,
                save: save
              };
            }
          }
        });
      };
      $scope.isFormAvailable = function(form) {
        switch (form) {
          case 'reschedule_single_event':
            return true;
          case 'reschedule_future_events':
            return $scope.isRepeating() && !$scope.event.this_event_only_frequency_change_performed && !$scope.isWeekly();
          case 'change_frequency':
            return $scope.isRepeating() && !$scope.event.this_event_only_frequency_change_performed;
          case 'change_to_infinite_events':
            return $scope.isRepeating() && !$scope.event.infinite;
          case 'change_repeat_until':
            return $scope.isRepeating();
          case 'change_weekly_session_time':
            return $scope.isRepeating() && $scope.isWeekly() && !$scope.event.this_event_only_frequency_change_performed;
        }
      };
      return $scope.$watch('event', function(newEvent) {
        if (!((newEvent != null) && (newEvent.repeat_interval_unit != null))) {

        }
      });
    }]
  };
});
